function openModalDesignDialog() {
    document.getElementById('modal-design-dialog-label').innerHTML = "Design Specification - " + activeProject.designTypeStr //+ activeProject.material['Type'];
    // if active project is custom or european steel disable LRFD and ASD and show message
    if(activeProject.isWood || activeProject.isNorthAmericanSteel || activeProject.isEngineeredLumber) {
        document.getElementById('design-available-warning').classList.add('hidden')
        document.getElementById('lrfd-combinations-tab').classList.remove('hidden')
        document.getElementById('asd-combinations-tab').classList.remove('hidden')
        if(activeProject.isLRFD) {
            toggleDesignButton(document.getElementById('lrfd-combinations-tab'))
        } else if(activeProject.isASD) {
            toggleDesignButton(document.getElementById('asd-combinations-tab'))
        } else {
            toggleDesignButton(document.getElementById('basic-design-tab'))
        }
    } else {
        document.getElementById('design-available-warning').classList.remove('hidden')
        document.getElementById('lrfd-combinations-tab').classList.add('hidden')
        document.getElementById('asd-combinations-tab').classList.add('hidden')
        document.getElementById('design-dialog-warning-text').innerHTML = "Only Basic Design is available for " +
            activeProject.material['Type'] + " shapes."
        toggleDesignButton(document.getElementById('basic-design-tab'))
    }
    updateLoadCombinationTableHeader()
    updateLoadCombinationTable()
    $('#modal-design-dialog').modal('show')
}

function initDesignDialog() {
    // validation
    $( "#deflection-limit-form" ).validate({
        rules: {
            'live-load-deflection-limit-input': {
                required: true,
                digits: true,
                min: 1
            },
            'dead-plus-live-load-deflection-limit-input' : {
                required: true,
                digits: true,
                min: 1
            },
            'snow-or-wind-load-deflection-limit-input' : {
                required: true,
                digits: true,
                min: 1
            },
            'total-load-deflection-limit-input' : {
                required: true,
                digits: true,
                min: 1
            },
        }
    });
}

function updateLoadCombinationTableHeader() {
    var design = activeProject.design
    if (design.designType === 'None') {
        let str = '<div>Load Cases</div><small>click individual load cases below to exclude</small>'
        document.getElementById('load-combination-table-header').innerHTML = str
        return
    }

    var title = `Use ${design.designType} Equations`
    var str ='<div><label class="checkbox-inline"><input type="checkbox" id="use-load-combo-equations" ' 
    str += 'onclick="onLoadCombinationEquationsClick();">'
    str += `${title} <br><small>click individual load cases below to exclude</small></label></div>`;
    if( !activeProject.isNorthAmericanSteel && (activeProject.isLRFD || activeProject.isASD) ) {
        str += '<input id="use-lambda-or-cd" type="checkbox" onclick="onUseLambdaOrCdClick();"/>';
        str += activeProject.isLRFD ? ' Use &lambda;' : ' Use Cd';
    }

    document.getElementById('load-combination-table-header').innerHTML = str
    
    var useEquations = (design.loadCombination !== null && design.loadCombination.name !== 'No Combos');
    $('#use-load-combo-equations').prop('checked', useEquations);
}

function updateLoadCombinationTable() {
    // Show nicely formated Equations
    var design = activeProject.design;
    if (design.loadCombination === null) {
        return;
    }

    var str = '<table class="table">';

    for( var i = 0; i < design.loadCombination.prettyEquations.length; i++ ) {
        if(design.loadCombination.prettyEquations[i]["common"] === false ) {
            continue;
        }
        if (design.loadCombination.prettyExclude[i] ) {
            str += '<tr style="padding: 6px;" class="ws-ui-table-row-disable" id="load-combination-row-' + i + '">';
        } else {
            str += '<tr style="padding: 6px;" id="load-combination-row-' + i + '" >';
        }
        // check column
        str += '<td style="padding: 6px;" class="wsLoadCombo_' + i + '" onclick="toggleLoadCombinationEquation(' + i + ');">'
        if( design.loadCombination.prettyExclude[i] ) {
            str += '<span id="load-combination-check-' + i + '"> </span> ';
        } else {
            str += '<span id="load-combination-check-' + i + '" class="glyphicon glyphicon-ok text-success"> </span> ';
        }

        str += design.loadCombination.prettyEquations[i]["EQ"] + '</td><td style="padding: 6px;">';
        if( !activeProject.isNorthAmericanSteel ) {
            if( design.loadCombination.name === "LRFD") {
                str += "<input class='ws-ui-factor-input' id='lambda-or-cd-"+i+"' type='text' ";
                str += "value='" + design.loadCombination.prettyEquations[i]["lambda"] + "' onchange='updateLambdaOrCd("+i+");'/>";
            } else if( design.loadCombination.name === "ASD") {
                str += "<input class='ws-ui-factor-input' id='lambda-or-cd-"+i+"' type='text' ";
                str += "value='" + design.loadCombination.prettyEquations[i]["Cd"] + "' onchange='updateLambdaOrCd("+i+");'/>";
            }
        }
        str += "</td></tr>";
    }
    str += "</table>";
    $("#load-combination-table").html(str);

    configureLambdaOrCdFields();
    $('#modal-design-dialog').trigger('design-type-changed');
}

function onLoadCombinationEquationsClick() {
    var useEquations = $('#use-load-combo-equations:checked').val() !== undefined;
    if(useEquations === false) {
        activeProject.design.loadCombination = noCombinations;
    } else if(activeProject.isLRFD) {
        activeProject.design.loadCombination = lrfdCombinations;
    } else if(activeProject.isASD) {
        activeProject.design.loadCombination = asdCombinations;
    }
    updateLoadCombinationTable();
}


function toggleLoadCombinationEquation(index) {
    $('#load-combination-row-' + index).toggleClass('ws-ui-table-row-disable');
    $('#load-combination-check-' + index).toggleClass('glyphicon glyphicon-ok text-success');
    activeProject.design.loadCombination.togglePrettyExclude(index);
}

function onUseLambdaOrCdClick() {
    configureLambdaOrCdFields();
}

function configureLambdaOrCdFields() {
    var useLambda = $('#use-lambda-or-cd:checked').val() !== undefined;
    activeProject.design.useLambdaOrCd = useLambda;
    for( var i = 0; i < activeProject.design.loadCombination.prettyEquations.length; i++ ) {
        if( activeProject.design.loadCombination.prettyEquations[i]["common"] === false )
            continue;
        if( useLambda) {
            $("#lambda-or-cd-"+i).removeClass('hidden');
        } else {
            $("#lambda-or-cd-"+i).addClass('hidden');
        }
    }
}

function toggleDesignButton(button) {
    document.getElementById('lrfd-combinations-tab').classList.remove('btn-primary')
    document.getElementById('lrfd-combinations-tab').classList.add('btn-default')
    document.getElementById('asd-combinations-tab').classList.remove('btn-primary')
    document.getElementById('asd-combinations-tab').classList.add('btn-default')
    document.getElementById('basic-design-tab').classList.remove('btn-primary')
    document.getElementById('basic-design-tab').classList.add('btn-default')
    if(button) {
        button.classList.add('btn-primary')
    }
}

function onLRFDDesignClick(button) {
    activeProject.design.designType = 'LRFD';
    activeProject.design.loadCombination = getLRFDCombinations();
    updateLoadCombinationTableHeader();
    updateLoadCombinationTable();
    markBeamDesignNeedsSaved();
    toggleDesignButton(button)
}

function onASDDesignClick(button) {
    activeProject.design.designType = 'ASD';
    activeProject.design.loadCombination = getASDCombinations();
    updateLoadCombinationTableHeader();
    updateLoadCombinationTable();
    markBeamDesignNeedsSaved();
    toggleDesignButton(button)
}

function onNoDesignClick() {
    activeProject.design.designType = 'None';
    activeProject.design.loadCombination = getNoCombinations();
    updateLoadCombinationTableHeader();
    updateLoadCombinationTable();
    markBeamDesignNeedsSaved();
    toggleDesignButton(document.getElementById('basic-design-tab'))
}

function updateDeflectionLimit() {
    activeProject.design.liveLoadLimit = parseInt($('#live-load-deflection-limit-input').val());
    activeProject.design.deadPlusLiveLoadLimit = parseInt($('#dead-plus-live-load-deflection-limit-input').val());
    activeProject.design.snowOrWindLoadLimit = parseInt($('#snow-or-wind-load-deflection-limit-input').val());
    activeProject.design.totalLoadLimit = parseInt($('#total-load-deflection-limit-input').val());
    $('#modal-design-dialog').trigger('design-deflection-limits-changed');
}
